import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message-view" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "content"
}
const _hoisted_6 = { class: "message-view__message-text" }
const _hoisted_7 = {
  key: 1,
  class: "content"
}
const _hoisted_8 = { class: "message-view__message-text" }
const _hoisted_9 = { class: "form" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "ADD YOUR REPLY", -1)
const _hoisted_12 = { class: "upload" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.image,
              alt: "artwork"
            }, null, 8, _hoisted_3),
            _createElementVNode("p", {
              class: "message-view__message-text",
              innerHTML: _ctx.htmlTitle
            }, null, 8, _hoisted_4)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversationMessages, (conversation) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "content-container",
              key: conversation.id
            }, [
              (conversation.participant_type === 'User')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("h3", null, _toDisplayString(conversation.participant.first_name) + " " + _toDisplayString(conversation.participant.last_name?.charAt(0)), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(conversation.message), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.secondParticipant.title), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(conversation.message), 1)
                  ])),
              _createVNode(_component_v_divider)
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("textarea", {
                  id: "message",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.messagetoSend) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.messagetoSend]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_file_input, {
                  multiple: "",
                  label: "Attachments",
                  onChange: _ctx.onFileChange,
                  class: "input"
                }, null, 8, ["onChange"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: _ctx.isSending
                }, _toDisplayString(_ctx.isSending ? 'SENDING…' : 'SEND MESSAGE'), 9, _hoisted_14)
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}